import { render, staticRenderFns } from "./BellAudio.vue?vue&type=template&id=72c0c91c&scoped=true&"
import script from "./BellAudio.vue?vue&type=script&lang=js&"
export * from "./BellAudio.vue?vue&type=script&lang=js&"
import style0 from "./BellAudio.vue?vue&type=style&index=0&id=72c0c91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0c91c",
  null
  
)

export default component.exports